<template>
  <section ref="root" class="dc-container">
    <div class="rasgado rasgado-top"></div>

    <div class="dc-card">
    
     

      <p ref="note" class="dc-note">
          <br>  Se reserva el color azul y toda su gama exclusivamente para la cumpleañera.     <br>
      </p>
<br>

      <img
        ref="paleta"
        src="@/assets/paleta.png"
        alt="Paleta de colores"
        class="dc-paleta"
      />
    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    const paleta = ref(null)

    onMounted(async () => {
      await nextTick()
      if (!root.value) return

      // Timeline con ScrollTrigger para entrada consecutiva (Staggered)
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%', // Se activa cuando llega al 85% del viewport
          toggleActions: 'play none none none' // Se reproduce una vez
        }
      })

      // 1. Entrada del título
      tl.from(title.value, {
        opacity: 0,
        y: -30,
        filter: 'blur(10px)',
        duration: 0.8,
        ease: 'power3.out'
      })

      // 2. Entrada de la etiqueta (Badge)
      .from(badge.value, {
        opacity: 0,
        scale: 0.5,
        duration: 0.5,
        ease: 'back.out(1.7)'
      }, "-=0.4")

      // 3. Entrada de la ilustración (vestido/traje)
      .from(figure.value, {
        opacity: 0,
        y: 20,
        scale: 0.9,
        duration: 0.6,
        ease: 'power2.out'
      }, "-=0.3")

      // 4. Entrada de la nota de texto
      .from(note.value, {
        opacity: 0,
        x: -20,
        duration: 0.5,
        ease: 'power2.out'
      }, "-=0.2")

      // 5. Entrada de la paleta de colores (Impacto final)
      .from(paleta.value, {
        opacity: 0,
        y: 30,
        scale: 0.8,
        duration: 0.7,
        ease: 'back.out(1.4)'
      }, "-=0.2")
    })

    onUnmounted(() => {
      ScrollTrigger.getAll().forEach(t => t.kill())
    })

    return { root, title, badge, figure, note, paleta }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background:#f3f7fd !important;
  padding: 34px 18px 62px; /* Aumentado padding inferior para la paleta */
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background:#f3f7fd !important;
  z-index: 1;
  pointer-events: none;
}

.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(
    0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%
  );
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'titulos', cursive;
  color:#043b73;
  font-size: 56px !important;
  margin: 0 0 16px;
  line-height: 1.05;
}

.dc-badge {
  display: inline-block;
  background: #ffffff;
  color: #1b1b1b;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 16px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin: 4px 0 12px;
}

.dc-figure {
  width: 180px;
  height: auto;
  display: block;
  margin: 30px auto 12px;
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 19px;
  color: #201f1f;
  opacity: 0.9;
  font-style: italic;
  font-weight: 500;
  margin: 10px auto 18px;
  line-height: 1.4;
}

/* Estilos para la Paleta de colores */
.dc-paleta {
  width: 100%;
  max-width: 320px;
  height: auto;
  display: block;
  margin: 20px auto 10px;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.05));
}

@media (max-width: 480px) {
  .dc-title {
    font-size: 52px;
  }
  .dc-paleta {
    max-width: 280px;
  }
}
</style>